import { actions, constants } from '../constants'
import { map } from 'lodash'

const { DYNAMIC_CHANNELS } = actions

const initialState = {
    loading: false,
    typesLoading: false,
    instancesLoading: false,
    dynamicChannels: [],
    channelTypes: [],
    channelInstances: [],
    pagination: [],
    errors: null,
    messages: null,
    selectedEntityType: null,
    selectedChannelType: null,
}

/**
 * @param state
 * @param action <Promise>
 */
export default function reducer(state = initialState, action) {

    switch (action.type) {
        case DYNAMIC_CHANNELS.RESET: {
            return {
                ...state, 
                loading: false, 
                typesLoading: false,
                instancesLoading: false,
                pagination: [], 
                dynamicChannels: [], 
                channelTypes: [],
                channelInstances: [],
                errors: null, 
                messages: null,
                selectedEntityType: null,
                selectedChannelType: null,
            }
        }
        case DYNAMIC_CHANNELS.START_TYPES: {
            return {...state, typesLoading: true}
        }
        case DYNAMIC_CHANNELS.START_INSTANCES: {
            return {...state, instancesLoading: true}
        }
        case DYNAMIC_CHANNELS.START: {
            return {...state, loading: true}
        }
        case DYNAMIC_CHANNELS.CLEAR_MESSAGES: {
            return {...state, messages: null, errors: null, errorCode: null}
        }
        case DYNAMIC_CHANNELS.ERROR: {
            let error = action.payload.response || {}

            const errorCode = error?.data?.code ?? null
            error = error.data ? error.data.message : "error.errorOccurred"
            
            return {
                ...state, 
                loading: false, 
                typesLoading: false,
                instancesLoading: false,
                errors: error, 
                errorCode: errorCode, 
                messages: null,
            }
        }
        case DYNAMIC_CHANNELS.SUCCESS: {
            return {...state, loading: false, typesLoading: false, instancesLoading: false, errors: null, messages: action.payload}
        }
        case DYNAMIC_CHANNELS.SAVE: {
            return {
                ...state, 
                loading: false, 
                dynamicChannels: action.payload.data,
                dynamicChannelsTransformed: map(action.payload.data, c => {
                    
                    // Add d6+ managed badge for integrated channels
                    const badges = []
                    if (c.integrations_d6_plus_channel) {
                        badges.push({
                            color: 'color-primary',
                            name: 'd6+ Managed'
                        })
                    }
                    
                    // Disable edit/delete actions for d6+ managed channels
                    const actions = []
                    if (!c.integrations_d6_plus_channel) {
                        actions.push(constants.MENU_ACTION_DELETE)
                    }
                    
                    return {
                        ...c,
                        is_visible: !c.is_hidden,
                        badges: badges,
                        actions: actions,
                        isDynamicChannel: c.integrations_d6_plus_channel || false
                    }
                }), 
                pagination: action.payload.pagination
            }
        }
        case DYNAMIC_CHANNELS.SAVE_CHANNEL_TYPES: {
            return {
                ...state, 
                typesLoading: false,
                channelTypes: map(action.payload, type => ({
                    key: type.channel_type_id,
                    value: type.channel_type_id,
                    text: type.name,
                    entityType: type.entity_type
                })),
                selectedEntityType: action.entityType,
                // Clear instances when channel types change
                channelInstances: [],
                selectedChannelType: null,
            }
        }
        case DYNAMIC_CHANNELS.SAVE_CHANNEL_INSTANCES: {
            return {
                ...state, 
                instancesLoading: false,
                channelInstances: map(action.payload, instance => ({
                    ...instance,
                    id: instance.channel_value,
                    name: instance.name,
                    status: instance.is_linked ? 'Already Linked' : '',
                    disabled: instance.is_linked,
                    disabled_reason: instance.is_linked ? 'Already Linked' : ''
                })),
                selectedChannelType: action.channelTypeId,
            }
        }
        case DYNAMIC_CHANNELS.CLEAR_CHANNEL_TYPES: {
            return {
                ...state,
                channelTypes: [],
                channelInstances: [],
                selectedEntityType: null,
                selectedChannelType: null,
            }
        }
        case DYNAMIC_CHANNELS.CLEAR_CHANNEL_INSTANCES: {
            return {
                ...state,
                channelInstances: [],
                selectedChannelType: null,
                instancesLoading: false,
                typesLoading: false,
            }
        }
        default: {}
    }

    return state
}
